// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Transition_wrapper__4Yq0P","content":"Transition_content__SadLC","logo":"Transition_logo__01YSS","Blink":"Transition_Blink__Oz_O1"};